import { FetchAllTrainingProgramsCompany } from "@store/company/procedure-training-store";
import { useEffect } from "react";
import makeAnimated from "react-select/animated";
import {
  $DirectoryTraining,
  FetchGetDirectoryTrainingTable,
} from "@store/directory-programm-training";
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import useModal from "@modals/modal-hook";
import useStyles from "@ui/material-ui-styles";
import { useUnit } from "effector-react";
import { useSelectedCompanyQuery } from "@lib/company";
import style from "@scss/modals/company/create-comission.module.scss";
import clsx from "clsx";
import ProcedureService from "@services/programs-service";

const animatedComponents = makeAnimated();

const CreateProgramModal = () => {
  const { modalComponent, modalData, close } = useModal();
  const classes = useStyles();
  const { training } = useUnit($DirectoryTraining);
  const { company } = useSelectedCompanyQuery();

  useEffect(() => {
    FetchGetDirectoryTrainingTable({});
  }, []);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const titleField = document.querySelector(
      'textarea[name="title"]'
    ) as HTMLInputElement;
    if (!company || !titleField.value.trim()) return;

    const modalBtn = document.querySelector(
      "button.modal_btn"
    ) as HTMLButtonElement;
    modalBtn.disabled = true;

    const termPrimaryConductingField = document.querySelector(
      'input[name="termPrimaryConducting"]'
    ) as HTMLInputElement;
    const periodField = document.querySelector(
      'input[name="period"]'
    ) as HTMLInputElement;
    const trainingField = document.querySelector(
      '[name="training"]'
    ) as HTMLInputElement;

    if (modalData.editMode) {
      ProcedureService.EditProgramStrict(
        modalData.programId,
        +trainingField.value,
        "training",
        {
          title: titleField.value,
          period: +periodField.value,
          termPrimaryConducting: +termPrimaryConductingField.value,
        },
        (err, res) => {
          if (err || !res) {
            return Error(
              "При ркдактировании программы обучения произошла ошибка"
            );
          }
          if (res.data) {
            FetchAllTrainingProgramsCompany(company.id);
            close();
          }
        }
      );
    } else {
      ProcedureService.PostProgramRowTableStrict(
        +trainingField.value,
        "training",
        {
          title: titleField.value,
          period: +periodField.value,
          termPrimaryConducting: +termPrimaryConductingField.value,
          company: company.id,
        },
        (err, res) => {
          if (err || !res) {
            return Error("При создании программы обучения произошла ошибка");
          }
          if (res.data) {
            FetchAllTrainingProgramsCompany(company.id);
            close();
          }
        }
      );
    }
  };

  return (
    <div
      key={modalComponent.key}
      className={clsx(style.create_comission_modal)}
    >
      <p className="modal_title">{modalData.modalTitle}</p>
      <div className="underline" />
      <form className={`modal_content ${classes.root}`} onSubmit={handleSubmit}>
        <FormControl variant="filled">
          <InputLabel>Категория</InputLabel>
          <Select
            name="training"
            defaultValue={
              modalData.training
                ? modalData.training
                : !!training && training[0]?.id
            }
            fullWidth
          >
            {!!training &&
              training.map((item) => (
                <MenuItem value={item.id}>{item.title}</MenuItem>
              ))}
          </Select>
        </FormControl>
        <TextField
          required
          autoFocus
          multiline
          rows={3}
          name={"title"}
          type={"text"}
          style={{ width: "100%", backgroundColor: "white" }}
          placeholder={"Наименование программы..."}
          variant="standard"
          defaultValue={modalData.title || ""}
        />
        <TextField
          defaultValue={modalData.termPrimaryConducting || 0}
          style={{ width: "100%", backgroundColor: "white" }}
          slotProps={{
            input: {
              inputProps: {
                min: 0,
                max: 9999,
                inputMode: "numeric",
                pattern: "[0-9]*",
              },
            },
          }}
          type={"number"}
          label={"Первичное обучение"}
          name={"termPrimaryConducting"}
          variant="filled"
        />
        <TextField
          style={{ width: "100%", backgroundColor: "white" }}
          defaultValue={modalData.period || 0}
          slotProps={{
            input: {
              inputProps: {
                min: 0,
                max: 9999,
                inputMode: "numeric",
                pattern: "[0-9]*",
              },
            },
          }}
          type={"number"}
          label={"Повторное обучение"}
          name={"period"}
          variant="filled"
        />

        <button type="submit" className="modal_btn">
          {modalComponent.btnText}
        </button>
      </form>
    </div>
  );
};

export default CreateProgramModal;
